import React from "react";
import { WebsiteRoutes } from "routes/WebsiteRoutes";

const App = () => {
	return (
		<div className="App">
			<WebsiteRoutes />
		</div>
	);
};

export default App;
